import { formatUrl } from '@monash/portal-frontend-common';
import { flattenFieldArray } from './transform-field-array';

// General transform that applies to all submit types. Implement submit type-specific transforms
// in their respective submit handlers if applicable
export const transformLinkForSubmission = (data) => {
  const { startTime, ...restData } = data; // The startTime field is incorporated into startDate

  return {
    ...restData,
    url: formatUrl(data.url),
    tags: flattenFieldArray(data.tags),
    filters: flattenFieldArray(data.filters),
  };
};
